<script lang="ts">
  import Navbar from './components/Navbar.svelte';
  import Video from './components/Video.svelte';
  import Contact from './components/Contact.svelte';
  import Paralax from './components/Paralax.svelte';
  import Main from './components/Main.svelte';
  import Slide from './components/Slide.svelte';
  import Footer from './components/Footer.svelte';
  import CSS from './components/CSS.svelte';
  import { onMount } from 'svelte';
  import { store, ActionType, useDispatch } from './components/Store';

  const dispatch = useDispatch();

  const handleContact = () => dispatch({ type: ActionType.toggleContact });

  onMount(() => document.body.setAttribute('style', 'opacity: 1;'));
</script>

<Navbar />
{#if $store.View.videoOpen}
  <Video />
{/if}
{#if $store.View.contactOpen}
  <Contact />
{/if}
<Paralax />
<Main>
  <Slide>
    <img loading="lazy" src="assets/img/2a.png" class="d-block w-100" alt="Slide1" />
    <img loading="lazy" src="favicon.png" alt="Logo" class="logo" />
  </Slide>
  <Slide style="margin-top: -25%;">
    <img loading="lazy" src="assets/img/korrektur.png" class="d-block w-100" alt="Slide2" />
    <img loading="lazy" src="assets/img/thermo.gif" class="thermo" alt="Thermometer" />
  </Slide>
  <Slide style="margin: -20% 0 -10% 0;">
    <img loading="lazy" src="assets/img/4.png" class="d-block w-100" alt="Slide3" />
  </Slide>
  <Slide>
    <img loading="lazy" src="assets/img/5.png" class="d-block w-100" alt="Slide4" />
  </Slide>
  <Slide>
    <img loading="lazy" src="assets/img/6.png" class="d-block w-100 cursor-pointer" alt="Slide5" on:click={handleContact} />
  </Slide>
</Main>
<Footer />
<CSS />

<style>
  .logo {
    position: absolute;
    top: 36%;
    left: 28%;
    height: 7.5%;
    width: auto;
    animation: anim 2s ease-in-out infinite;
  }

  @keyframes anim {
    0% {
      transform: translateY(0%);
    }
    50% {
      transform: translateY(-100%);
    }
    100% {
      transform: translateY(0%);
    }
  }

  .thermo {
    position: absolute;
    height: 15%;
    width: auto;
    top: 15%;
    left: 60%;
  }

  .cursor-pointer {
    cursor: pointer;
  }
</style>
